<template>
  <div class="head">
    <div class="header-content content-width">
      <Menus @login="login" />
      <div style="display: flex; align-items: center">
        <el-popover v-if="isLogin && useStore.userInfo" transition="el-zoom-in-top" :offset="4" :popper-style="{
          padding: '8px 0',
          '--el-popover-border-radius': '10px',
        }" trigger="hover">
          <template #reference>
            <div class="user">
              <div class="avatar">
                <el-avatar :size="36" :src="useStore.userInfo.icon" />
                <img v-if="useStore.userInfo.newMemberLevel" class="vip-icon" src="/icon/ythy.png" alt="" />
              </div>
              <div class="username">
                <span class="name">{{ useStore.userInfo.nickName }}</span>
                <span style="font-size: 12px; color: #a9a9af" v-if="useStore.userInfo.newMemberLevel === 1">
                  {{
                    "会员有效期至" +
                    dayjs(useStore.userInfo.newMemberEndTime).format(
                      "YYYY-MM-DD"
                    )
                  }}
                </span>
                <span style="font-size: 12px; color: #a9a9af" v-else-if="useStore.userInfo.newMemberLevel === 2">
                  {{
                    "PLUS会员有效期至" +
                    dayjs(useStore.userInfo.newMemberEndTime).format(
                      "YYYY-MM-DD"
                    )
                  }}
                </span>
                <span style="font-size: 12px; color: #a9a9af" v-else>
                  暂未开通会员
                </span>
              </div>
            </div>
          </template>
          <!-- <div class="user-option">个人中心</div> -->
          <div class="user-option" @click="switchAccount">切换账号</div>
          <div class="user-option" @click="logout">退出登录</div>
        </el-popover>
        <el-button v-else type="primary" round @click="login">登录/注册</el-button>
      </div>
    </div>
    <el-dialog v-model="status.show" width="500" align-center>
      <div class="tips-dialog">
        <img :src="status.img" width="80%" alt="" style="margin-left: 50px" />
      </div>
    </el-dialog>
  </div>
</template>

<script setup lang="ts">
import login from "../login";
import Menus from "./Menus.vue";
import { dayjs } from "element-plus";
import { useUserStore } from "@/store/user.store";
import { reactive, ref } from "vue";

const status = reactive({
  show: false,
  img: "",
});

const isLogin = Boolean(localStorage.getItem("token")); //localStorage.getItem('token')
const useStore = useUserStore();
const opBanner = (bannerData: any) => {
  if (bannerData.saleCodeUrl) {
    status.show = true;
    status.img = bannerData.saleCodeUrl;
  } else if (bannerData.dynamicData) {
    window.open(bannerData.dynamicData);
  }
};
const logout = () => {
  localStorage.clear();
  location.reload();
};

const switchAccount = () => {
  login();
};

isLogin && useStore.getUserInfo();
</script>

<style scoped lang="less">
.tips-dialog {
  padding: 0 !important;
  border-radius: 30px !important;
  background-color: white;
}

.head {
  // &::after {
  //   position: fixed;
  //   top: 0;
  //   left: 0;
  //   right: 0;
  height: 60px;
  box-shadow: 0 1px 3px hsla(0, 0%, 7%, 0.1);
  // content: "";
  // background-image: radial-gradient(transparent 1px, #fff 1px);
  // background-size: 4px 4px;
  // backdrop-filter: saturate(50%) blur(11px);
  background-color: #fff;
  // z-index: -1;
  // }

  // position: sticky;
  // left: 0;
  // top: 0;

  z-index: 1001;

  .header-content {
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    height: 100%;
  }

  .banner {
    border-radius: 8px;
  }

  .logo {
    display: flex;
    align-items: center;
    margin-right: 24px;
  }

  .el-menu {
    border-bottom: none;

    .el-menu-item {
      padding: 0;
      margin: 0 20px;
      background-color: #fff;
    }

    .el-menu-item.is-active {
      background-color: #fff;
    }

    .el-menu-item:not(.is-disabled):hover {
      background-color: #fff;
    }
  }

  .user {
    display: flex;
    line-height: 1.4em;

    .avatar {
      position: relative;
      margin-right: 8px;

      .vip-icon {
        width: 18px;
        height: 18px;
        position: absolute;
        z-index: 1;
        right: 0;
        bottom: 0;
      }
    }

    .username {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    .name {
      font-size: 14px;
    }

    .tips {
      font-size: 12px;
      color: #a9a9af;
    }
  }
}
</style>
